// extracted by mini-css-extract-plugin
module.exports = {"btns":"Stack_btns__2BnY6","btn":"Stack_btn__3D0ox"};